export const createCookieName = (user_uuid, service_uuid) => {
  return `${user_uuid}*${service_uuid}`;
};
